import { render, staticRenderFns } from "./IconSummary.vue?vue&type=template&id=1eb1c34a&"
var script = {}
import style0 from "./IconSummary.vue?vue&type=style&index=0&id=1eb1c34a&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports